<template>
  <section class="section apply">
    <div class="apply-wrapper">
      <div class="apply-box">
        <div class="apply-content" v-html="applyContent"></div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'

const applyContent = ref('')
const { locale } = useI18n()

watchEffect(async () => {
  const lang = locale.value
  try {
    const fileUrl = `/translatorapply/${lang}.html`
    applyContent.value = await fetch(fileUrl).then(res => res.text())
  } catch (error) {
    applyContent.value = `<p>İçerik yüklenemedi.</p>`
    console.error('Başvuru içeriği yüklenemedi:', error)
  }
})
</script>

<style scoped>
.apply-wrapper {
  display: flex;
  justify-content: center;
  padding: 100px 20px 60px; /* Header ile boşluk */
  background: #f8f8f847;
  min-height: 100vh;
}

.apply-box {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  max-width: 900px;
  width: 100%;
  box-sizing: border-box;
}

.apply-content :deep(h1),
.apply-content :deep(h2) {
  text-align: center;
  color: #000000;
  margin-top: 40px;
  margin-bottom: 20px;
}

.apply-content :deep(h1) {
  font-size: 3em;
}

.apply-content :deep(h2) {
  font-size: 2em;
}

.apply-content ul {
  list-style: disc;
  padding-left: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.apply-content li {
  margin-bottom: 8px;
}

.apply-content :deep(a) {
  display: inline-block;
  background-color: #2563eb;
  color: white;
  padding: 10px 24px;
  border-radius: 6px;
  text-decoration: none;
  margin-top: 1.5rem;
  text-align: center;
  transition: background-color 0.3s ease;
}

.apply-content a:hover {
  background-color: #1e40af;
}
@media (max-width: 768px) {
  .apply-wrapper {
    padding: 60px 15px 40px;
  }

  .apply-box {
    padding: 25px 20px;
  }

  .apply-content :deep(h1) {
    font-size: 2rem;
  }

  .apply-content :deep(h2) {
    font-size: 1.5rem;
  }

  .apply-content :deep(a) {
    width: 100%;
    text-align: center;
    padding: 12px;
    font-size: 1rem;
  }

  .apply-content ul {
    padding-left: 20px;
  }
}

</style>
